<div class="add-on-block">
  <div class="label paragraph-medium-regular">{{ label }}
    <mat-icon class="custom-tooltip-help-icon" [tp]="tooltipTemplateAddOn" tpMaxWidth="400px" [tpInteractive]="true" tpPlacement="right">help</mat-icon>
  </div>
  <ng-template #tooltipTemplateAddOn >
    <div [innerHTML]="returnTooltipInformation()"></div>
  </ng-template>
  <mat-button-toggle-group
    class="add-on-toggle"
    [(ngModel)]="toggle"
    (change)="onInputChange()"
    [disabled]="isReadOnly"
  >
    <mat-button-toggle class="btn-toggle" [value]="true">Yes</mat-button-toggle>
    <mat-button-toggle class="btn-toggle" [value]="false">No</mat-button-toggle>
  </mat-button-toggle-group>
  <ng-container *ngIf="toggle == true">
    <div class="form-inputs form-padding">
      <div class="label paragraph-medium-regular">Quantity</div>
      <input
        class="normal-txtbox paragraph-medium-regular"
        type="number"
        min="0"
        [max]="priceQuantity"
        step="0.01"
        [placeholder]="0"
        (input)="restrictNegativeNumberInput($event)"
        [(ngModel)]="quantity"
        (change)="onInputChange()"
        [readonly]="isReadOnly"
        [disabled]="isReadOnly"
      />
    </div>
    <div class="form-inputs form-padding">
      <div class="label paragraph-medium-regular">Duration</div>
      <div class="duration-block">
        <div class="input-block">
          <input
            class="normal-txtbox paragraph-medium-regular"
            type="number"
            min="0"
        
            step="1"
            [placeholder]="0"
            [(ngModel)]="years"
            (change)="onInputChange()"
            [readonly]="isReadOnly"
            [disabled]="isReadOnly"
          />
          <span class="paragraph-medium-regular hint-text">Years</span>
        </div>
        <div class="input-block">
          <input
            class="normal-txtbox paragraph-medium-regular"
            type="number"
            min="0"
            [max]="11"
            step="1"
            [placeholder]="0"
            [(ngModel)]="months"
            (change)="onInputChange()"
            [readonly]="isReadOnly"
            [disabled]="isReadOnly"
          />
          <span class="paragraph-medium-regular hint-text">Months</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>
